import { render } from "./Instant.vue?vue&type=template&id=68845600&scoped=true"
import script from "./Instant.vue?vue&type=script&lang=js"
export * from "./Instant.vue?vue&type=script&lang=js"

import "./Instant.vue?vue&type=style&index=0&id=68845600&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68845600"]])

export default __exports__